// ** React Imports
import { useEffect, useState, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import Navbar from "@layouts/components/navbar";
import Footer from "@layouts/components/footer";
import { ToastContainer } from "react-toastify";
import GoTop from "../components/GoTop";
import { getShareInfo } from "@store/common/actions";
import { getCodeLanguage, getShareInfoSelector } from "@store/common/selectors";
import ButtonFixed from "@components/ButtonFixed";
import { useRouteMatch, useHistory } from "react-router";
import { PhoneIcon } from "../assets/svg/index";
import MainImg from "../assets/images/main-img.png";

import { useMediaQuery } from "react-responsive";

const blankUrl = [
  "/signup",
  "/login",
  "/forgot-username",
  "/forgot-password",
  "/verify",
  "/verify",
  "/active",
  "/accounts",
  "/active-code",
  "/confirm-v2",
  "/confirm-forgot-v2",
  "/loading",
  "/confirm-parent-v2",
  "/confirm-password-v2",
  "/referral",
  "/confirm-contract-otp",
];

const BlankLayout = ({ children, ...rest }) => {
  const dispatch = useDispatch();
  const { url } = useRouteMatch();
  const { push } = useHistory();
  const convert = (url1 = "") => {
    const urlClone = url;

    const arr = urlClone.split("/");

    return "/" + arr[1];
  };

  const isMobile = useMediaQuery({ maxWidth: 767 });

  // console.log(convert(url));

  // ** States
  const [isMounted, setIsMounted] = useState(false);

  const codeLanguage = useSelector((state) => getCodeLanguage(state));
  const formData = useSelector((state) => getShareInfoSelector(state));

  useEffect(() => {
    dispatch(getShareInfo());
  }, [codeLanguage]);

  //** ComponentDidMount
  useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);

  if (!isMounted) {
    return null;
  }
  const className = url.toLowerCase() === "/buycourse" ? "BuyCourse " : "";
  return (
    <Fragment>
      {blankUrl.includes(convert(url)) ? (
        children
      ) : (
        <div className={className}>
          <div className="app-content content">
            <div className="content-wrapper">
              <div className="content-header">
                <Navbar data={formData} />
              </div>
              <div className="content-body">
                {children}
                <ButtonFixed allowLeft={false} allowRight={true} />
              </div>
              <Footer />
            </div>
          </div>
          {/* {!isMobile && (
            <>
              <div className="frame-item">
                <div className="d-flex flex-column align-items-end gap-2">
                  <div className="try-product">Trải nghiệm sản phẩm</div>
                  <div className="d-flex flex-row justify-content-around align-items-center gap-2 frame">
                    <div>
                      <PhoneIcon />
                    </div>
                    <a href="tel:0939 279 868" className="phone-title">
                      0939 279 868
                    </a>
                  </div>
                </div>
              </div>

              <div
                style={{ cursor: 'pointer' }}
                className="main-img-item"
                onClick={() => push('/download')}
              >
                <img src={MainImg} alt="main-img-item" className="main-img" />
              </div>
            </>
          )} */}
          <GoTop scrollStepInPx="50" delayInMs="16.66" />
        </div>
      )}

      <ToastContainer
        position="top-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Fragment>
  );
};

export default BlankLayout;
